import { useAnalytics } from "@codat/analytics";
import { CodeBlock as OrchardCodeBlock } from "@codat/orchard-ui";
import { CodeBlockProps as OrchardCodeBlockProps } from "@codat/orchard-ui/dist/es/components/CodeBlock";
import React from "react";

interface CodeBlockProps extends OrchardCodeBlockProps {
  codeBlockName: string;
  eventProperties?: Record<string, unknown>;
}

export const CodeBlock: React.FC<CodeBlockProps> = (props) => {
  const {
    codeBlockName,
    eventProperties,
    downloadOptions,
    copyOptions,
    ...codeBlockProps
  } = props;

  const { sendEvent } = useAnalytics();

  const handleDownloadClick = () => {
    if (!downloadOptions) {
      return;
    }
    sendEvent(`${codeBlockName} download icon - Click`, eventProperties);
    downloadOptions.onClick && downloadOptions.onClick();
  };

  const handleCopyClick = () => {
    if (!copyOptions) {
      return;
    }
    sendEvent(`${codeBlockName} clipboard icon - Click`, eventProperties);
    copyOptions.onClick && copyOptions.onClick();
  };

  return (
    <OrchardCodeBlock
      {...codeBlockProps}
      downloadOptions={
        downloadOptions
          ? {
              ...downloadOptions,
              onClick: handleDownloadClick,
            }
          : undefined
      }
      copyOptions={
        copyOptions ? { ...copyOptions, onClick: handleCopyClick } : undefined
      }
    />
  );
};
